<div class="profile-popup-wrapper">
  <div class="profile-display-container">
    <div class="background-container">
      <img
        src="../../../../assets/images/ibc-customer-logo.svg"
        width="150"
        alt="ibc-logo" />
      <div class="avatar-and-username-container">
        <div class="avatar">
          <span>{{ avatar }}</span>
        </div>
        <div class="username">
          <span>{{ userDetails?.fullName }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="profile-header">
    <span class="ibc-customer-heading-h6-bold-primary-dark">
      User Information
    </span>
    <button
      mat-button
      class="mat-button-md ibc-primary-dark-button-md"
      (click)="onEdit()"
      [disabled]="showSaveButton">
      Edit
    </button>
  </div>

  <div class="profile-info-container" [formGroup]="profileForm">
    @for (field of profileInfoFormFieldConfig; track field.id) {
      @if (field.type === 'select') {
        <mat-form-field
          appearance="outline"
          class="mat-md mat-select-variant air-waybill-form-fields">
          <mat-label>{{ field.label }}</mat-label>
          <mat-select
            *ngIf="field.id === 'measurementOptions'"
            formControlName="{{ field.id }}">
            <mat-option
              *ngFor="let item of measurementOptionsList"
              [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
          <app-svg-icon
            [isStaticSvg]="true"
            [iconName]="'arrowDownward'"
            matSuffix></app-svg-icon>
          <mat-error
            *ngIf="
              profileForm.get(field.id)?.invalid &&
              profileForm.get(field.id)?.touched
            ">
            {{ getErrorMessage(field.id) }}
          </mat-error>
        </mat-form-field>
      } @else {
        <mat-form-field
          appearance="outline"
          class="mat-md air-waybill-form-fields">
          <mat-label>{{ field.label }}</mat-label>
          <input matInput formControlName="{{ field.id }}" />
          <mat-error
            *ngIf="
              profileForm.get(field.id)?.invalid &&
              profileForm.get(field.id)?.touched
            ">
            {{ getErrorMessage(field.id) }}
          </mat-error>
        </mat-form-field>
      }
    }
  </div>

  <div class="profile-popup-footer">
    <button
      mat-button
      class="mat-button-md ibc-secondary-dark-button"
      (click)="onClose()">
      Close
    </button>
    <button
      *ngIf="showSaveButton"
      mat-button
      class="mat-button-md ibc-primary-dark-button-md"
      (click)="onSave()">
      Save
    </button>
  </div>
</div>
